import * as React from 'react';
import { Popper } from '@mui/base/Popper';
import { ClickAwayListener } from '@mui/base/ClickAwayListener';
import Button from '../Button/Button';
import { useImperativeHandle, useRef } from 'react';

type Props = React.PropsWithChildren<{
  button?: React.ReactElement;
  actionsRef?: any;
}> &
  Pick<React.ComponentProps<typeof Popper>, 'placement'>;

function Popup(props: Props) {
  const {
    button = <Button>Open</Button>,
    children,
    placement,
    actionsRef,
  } = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const buttonRef = useRef<HTMLButtonElement>();

  useImperativeHandle(actionsRef, () => ({
    close() {
      setAnchorEl(null);
    },
  }));

  const onButtonClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const onOutSideClick = (event: MouseEvent | TouchEvent) => {
    if (event.target === buttonRef?.current) {
      return;
    }

    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      {React.cloneElement(button, { onClick: onButtonClick, ref: buttonRef })}
      <ClickAwayListener onClickAway={onOutSideClick}>
        <Popper open={open} anchorEl={anchorEl} placement={placement}>
          {open ? <div>{children}</div> : null}
        </Popper>
      </ClickAwayListener>
    </>
  );
}

export default Popup;
